import * as React from "react";
import { SVGProps } from "react";
export const BriefcaseFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 12.5V10.5H11V12.5H9ZM7.5 5H12.5V3.5H7.5V5ZM3.5 17C3.0875 17 2.73438 16.8531 2.44063 16.5594C2.14688 16.2656 2 15.9125 2 15.5V12.25H7.5V13.25C7.5 13.4625 7.57188 13.6406 7.71563 13.7844C7.85938 13.9281 8.0375 14 8.25 14H11.75C11.9625 14 12.1406 13.9281 12.2844 13.7844C12.4281 13.6406 12.5 13.4625 12.5 13.25V12.25H18V15.5C18 15.9125 17.8531 16.2656 17.5594 16.5594C17.2656 16.8531 16.9125 17 16.5 17H3.5ZM2 10.75V6.5C2 6.0875 2.14688 5.73438 2.44063 5.44063C2.73438 5.14688 3.0875 5 3.5 5H6V3.49562C6 3.08187 6.14687 2.72917 6.44063 2.4375C6.73438 2.14583 7.0875 2 7.5 2H12.5C12.9125 2 13.2656 2.14688 13.5594 2.44063C13.8531 2.73438 14 3.0875 14 3.5V5H16.5C16.9125 5 17.2656 5.14688 17.5594 5.44063C17.8531 5.73438 18 6.0875 18 6.5V10.75H12.5V9.75C12.5 9.5375 12.4281 9.35937 12.2844 9.21562C12.1406 9.07187 11.9625 9 11.75 9H8.25C8.0375 9 7.85938 9.07187 7.71563 9.21562C7.57188 9.35937 7.5 9.5375 7.5 9.75V10.75H2Z"
            fill="currentColor"
        />
    </svg>
);
BriefcaseFillIcon.displayName = "BriefcaseFillIcon";
